import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { Check, Loader2 } from "lucide-react";
import { TOK, SERIF, SANS } from "../soulumoCreate/shared";
import { openPaddleIfActive } from "../voiceClone/paddleCheckout";
import { API, auth, StepTitle } from "./DemoBits";
import { visitorId } from "../../lib/via";

const PERKS = ["Create your own personalised installations", "Use your own cloned voice", "Choose your music and mood journeys",
  "Create new installations whenever you need them", "Your personal Soulumo library"];

const Plan = ({ active, onClick, price, per, tag, testId, was }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className="rounded-2xl px-4 py-4 text-left transition-[border-color,background-color] duration-200"
    style={{ border: `1px solid ${active ? TOK.gold : "rgba(245,236,217,0.18)"}`, background: active ? "rgba(215,187,122,0.1)" : "transparent" }}>
    <p className="text-[0.58rem] uppercase tracking-[0.26em]" style={{ color: TOK.gold, fontFamily: SANS }}>{tag}</p>
    <p className="mt-1 text-2xl" style={{ fontFamily: SERIF, color: TOK.cream }}>{was && <span className="mr-1.5 text-base line-through" style={{ color: TOK.creamDim }} data-testid="demo-plan-was">{was}</span>}{price} <span className="text-sm italic" style={{ color: TOK.creamDim }}>{per}</span></p>
  </button>
);

export const DemoPaywall = ({ reason }) => {
  const [plan, setPlan] = useState(new URLSearchParams(window.location.search).get("plan") === "annual" ? "annual" : "monthly");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const { user } = useAuth();
  const nav = useNavigate();
  const go = async () => {
    if (!user) { nav(`/soulumo/join?next=${encodeURIComponent(`/soulumo/demo?step=pay&plan=${plan}`)}`); return; }
    setBusy(true); setMsg("");
    axios.post(`${API}/api/soulumo/demo/event`, { event: "checkout", visitor_id: visitorId() }, auth()).catch(() => {});
    try {
      if (await openPaddleIfActive({ plan, source: "demo_paywall" })) { setBusy(false); return; }
      const r = await axios.post(`${API}/api/voice-clone/checkout`, { origin_url: window.location.origin, plan }, auth());
      window.location.href = r.data.checkout_url;
    } catch { setMsg("We couldn't open checkout. Please try again."); setBusy(false); }
  };
  return (
    <div data-testid="demo-paywall">
      <StepTitle kicker="Foundational Membership" title="Ready to create yours?" />
      {reason && <p className="-mt-3 mb-5 text-sm" style={{ color: TOK.creamDim, fontFamily: SANS }} data-testid="demo-paywall-reason">{reason}</p>}
      <ul className="space-y-2.5">
        {PERKS.map((p) => (
          <li key={p} className="flex items-start gap-3 text-[0.98rem]" style={{ color: TOK.cream, fontFamily: SANS }}>
            <Check size={16} className="mt-1 shrink-0" style={{ color: TOK.gold }} /> {p}
          </li>
        ))}
      </ul>
      <div className="mt-7 grid grid-cols-2 gap-3">
        <Plan active={plan === "monthly"} onClick={() => setPlan("monthly")} tag="Founding member · monthly" was="£9.99" price="£6.99" per="/ month" testId="demo-plan-monthly" />
        <Plan active={plan === "annual"} onClick={() => setPlan("annual")} tag="Yearly · over 3 months free" price="£60.99" per="/ year" testId="demo-plan-annual" />
      </div>
      <button type="button" onClick={go} disabled={busy} data-testid="demo-create-mine-btn"
        className="mt-7 w-full rounded-full py-4 text-[0.74rem] uppercase tracking-[0.24em] inline-flex items-center justify-center gap-2 transition-transform duration-200 active:scale-[0.98] disabled:opacity-60"
        style={{ background: TOK.gold, color: "#0d1f3a", fontFamily: SANS }}>
        {busy && <Loader2 size={14} className="animate-spin" />} Create mine · {plan === "monthly" ? "£6.99 / month" : "£60.99 / year"}
      </button>
      <p className="mt-3 text-center text-xs" style={{ color: TOK.creamDim, fontFamily: SANS }}>{user ? "Cancel any time. Your voice recording starts right after you join." : "First create your free account, then choose your plan. Cancel any time."}</p>
      {msg && <p className="mt-2 text-center text-sm text-red-300" data-testid="demo-paywall-error">{msg}</p>}
    </div>
  );
};
